import type {JSX} from 'react'
import type {JsonLdGraph} from '@/schema/types'

export function JsonLd({graph}: Readonly<{graph: JsonLdGraph}>): JSX.Element {
	const json = JSON.stringify(graph).replaceAll('<', String.raw`\u003c`)
	return (
		<script
			dangerouslySetInnerHTML={{
				__html: json,
			}}
			type="application/ld+json"
		/>
	)
}
